export default __webpack_public_path__ + "static/media/gallery_06.dc2478af.jpg";